import React from "react";
import '../../../App.scss';
import backgroundImage from "../../../assets/images/main_background.png";
import HeaderBackgroundImage from "../../../assets/images/saturn.png";
import Grid from "@material-ui/core/Grid";
import Toolbar from "../../Toolbar";
import Polygon from "../../pageComponents/Home/GiftHall/Polygon";
import GiftHallOffer from "../../pageComponents/Home/GiftHall/GiftHallOffer";
import Timer from "../../pageComponents/Home/GiftHall/Timer";
import Divider from "../../pageComponents/Home/GiftHall/Divider";
import Treasure from "../../../assets/images/speacialDiscountTreasure.png";
import CircleOrange from "../../../assets/images/circle_orange.png";
import GreenButton from "../../../assets/images/green_btn.png";
import OrangeButton from "../../../assets/images/orange_button.png";
import YellowButton from "../../../assets/images/yellow_button.png";
import StartButton from "../../pageComponents/Home/LeagueStart/StartButton";
import axios from "axios";
import {buy, giftHallCheck, giftHallList, userData} from "../../../Utility/Url";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "../../pageComponents/Common/Dialog";
import Dialog from "@material-ui/core/Dialog";
import HelpDialog from "../../pageComponents/Home/GiftHall/HelpDialog";
import {stars} from "../../../Store/Actions/StarsAction";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import {giftHallDialog} from "../../../Store/Actions/GiftHallDialogAction";
import PolygonHolder from "../../pageComponents/Home/GiftHall/PolygonHolder";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import ShopDialog from "../../pageComponents/Common/ShopDialog";
import GifHallPolygonDetail from "../../pageComponents/Common/GifHallPolygonDetail";
class GiftHall extends React.Component{
    constructor() {
        super()
        this.state= {
            appHasLoaded: false,
            timer:null,
            seconds:5,
            showDialog:true,
            detailDialog:null,
            polygonDetailVisible:false,
            data:null,
            showGoldenPathDialog:false,
            greenButtonLoader:false,
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    // backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize:'100% 100%',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor:"orange",
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0',
                    overflowY:'hidden',
                },
            }
        }
    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.data(data)
                this.setState({
                    allDataLoaded:true
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    giftHallList= async()=>{
        await axios.get(giftHallList)
            .then(res => {
                const {data}=res
                // this.props.data(data)
                // console.log(data)
                // if (data.active)
                this.setState({
                    data:data,
                    seconds:data.timeLeft
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    handleShowGoldenPathDialog=()=>{
        const {showGoldenPathDialog,data:{shopItem: {id}}}=this.state

        if (showGoldenPathDialog){
            this.setState({
                greenButtonLoader:true
            })
            localStorage.setItem('redirect','/gift-hall')
            axios.post(buy,{
                id:id,
                url:`${URL}/home`
            }).then(res => {
                const {data}=res
                this.setState({
                    picoSmallLoader:false
                })
                localStorage.setItem('redirect','/gift-hall')
                window.location.href=data.url
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
        }
       else {
            this.setState({
                showGoldenPathDialog:true
            })
        }
    }
    mainClick=()=>{
        const { showGoldenPathDialog} = this.state
        if (showGoldenPathDialog)
            this.setState({
                showGoldenPathDialog:false
            })
    }
    polygonDetail=(data)=>{
        const {showGoldenPathDialog}=this.state
        if (!showGoldenPathDialog)
            this.setState({
                polygonDetailVisible:true,
                detailDialog: {...data,background:this.state.data.centerColor},
            })
    }
    componentWillUnmount() {
        this.props.giftHallDialog(false)
    }

    componentDidMount() {
        this.fetchData()
        this.giftHallList()
        this.props.toggleBottomNavbar()
        this.props.giftHallDialog(true)
    }

    render() {
        const handleClose=(()=>{
            this.setState({
                polygonDetailVisible:false
            })
        })
        let items=[
            {
                icon:Treasure,
                text:'6',
                textColor:'yellow',
                locked:true,
                hasGlowBackground:true,
            },
        ]
        const goldenPathButton={
            backgroundImage:YellowButton,
            text:'مسیر طلایی',
            icon:null,
            iconText:'awd'
        }
        const regularPathButton={
            backgroundImage:OrangeButton,
            text:'مسیر عادی',
            icon:null,
            iconText:'awd'
        }
        let shopItem={
            bannerActive: 0,
            bannerUrl: "http://picopool.ir/_data/banner/35_optimized.png",
            fullPrice: 99000,
            giftVal: 0,
            hallName: "ثور - فصل سوم",
            icon: "http://picopool.ir/_data/_shop/gold3_optimized.png",
            id: 20,
            isVisible: 0,
            name: "تالار جایزه",
            price: 22900,
            qIcon: "http://picopool.ir/_data/_shop/golden_coin.png",
            quantity: 1,
            sessonNumber: "0",
            shopIcon: "http://picopool.ir/_data/banner/prize.png",
            shopText: "اگه کلی جایزه و سکه میخوای، مسیر طلایی رو فعال کن تا بتونی خیلی بیشتر از هزینه ای که میدی سکه و .... کسب کنی",
            type: "giftHall",
            typeDesc: "giftHall"
        }
        let Rewards_vip={
            TOM: 0,
            golden: "125",
            rollvip: 0,
            silver: 0,
        }
        let timerData={
            seconds:100
        }
        const {data,showGoldenPathDialog,seconds,detailDialog}=this.state
        if (data){
            shopItem=data.shopItem
            Rewards_vip=data.Rewards_vip
            timerData={
                seconds: this.state.seconds
            }
            items=data.list.map(data=>{
                return{
                    conditionType: data.conditionType,
                    conditionValue: data.conditionValue,
                    giftType_normal: data.giftType_normal,
                    giftType_vip: data.giftType_vip,
                    giftValue_normal: data.giftValue_normal,
                    giftValue_vip: data.giftValue_vip,
                    id: data.id,
                    name: data.name,
                    normalImg: data.normalImg,
                    normalImg_: data.normalImg_,
                    orderr: data.orderr,
                    vipImg: data.vipImg,
                    vipImg_: data.vipImg_
                    // icon:Treasure,
                    // text:'6',
                    // textColor:'yellow',
                    // locked:true,
                    // hasGlowBackground:true,
                }
            })
        }
        const startButton={
            backgroundImage:GreenButton,
            text:showGoldenPathDialog?(data.shopItem?data.shopItem.price:''):'خرید مسیر طلایی',
            icon:null,
            iconText:'awd'
        }
        return(
            <Grid style={this.state.style.root} direction={"column"} item container>
                <Dialog
                    // disableBackdropClick
                    open={this.state.polygonDetailVisible}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            overflow:'visible'
                        },
                    }}
                >
                    <DialogContent style={{overflow:'visible'}}>
                        <GifHallPolygonDetail data={detailDialog}/>
                    </DialogContent>
                </Dialog>
                {
                    data &&
                    <Grid item sm={12} justify={'center'} container direction={"column"} style={{flex:'1',minHeight:'0',position:'relative'}}

                    >
                        <Grid alignItems={"center"} container style={{maxHeight:'85px'}}>
                            <Toolbar type='sideToolbar'/>
                        +</Grid>
                        <Grid item container xs={12} justify={"center"} sm={12}
                              onClick={()=> {
                                  this.mainClick()
                              }}
                              className='scrollBar giftHallBackground'
                              style={{flex:'1',minHeight:'0',overflow:'auto',
                                  // backgroundImage: "url(" + backgroundImage + ")," +
                                  //     "linear-gradient(90deg,"+ data.rectColor +" 50%, #6d056a 50%)",
                                  backgroundImage: `url(${backgroundImage}), linear-gradient(90deg, ${data.centerColor} 50%, ${data.startColor} 50%)`,
                                  backgroundSize:'100% 100%',
                                  backgroundRepeat: 'no-repeat',
                                  width: '100%',
                                  backgroundBlendMode:'soft-light',
                              }}>
                            <Grid container style={{backgroundImage: "url(" + data.banner + ")", backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat', width: '100%', backgroundBlendMode:'soft-light'}}>
                                <Grid container xs={12} justify={"center"} sm={12} alignItems={"center"} className='giftHallBackground-header'>
                                    <Grid container direction={"column"} xs={6} justify={"center"} sm={6} alignItems={"center"} >
                                        <Grid item>
                                            <p className='giftHallBackground-header-text'>
                                                {data.text}
                                            </p>
                                        </Grid>
                                        <Grid item container style={{marginTop:'40px'}}>
                                            <Timer data={timerData}/>
                                        </Grid>
                                    </Grid>
                                    <Grid container xs={6} justify={"center"} sm={6} alignItems={"center"} >
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className='gift-hall-divider-banner' direction={"row-reverse"} justify={"space-around"} container sm={12} xs={12} >
                                <Grid className='gift-hall-divider-banner-golden-path' style={{position:'relative',height:'100%'}} container sm={4} xs={4} alignItems={"center"} justify={"center"}>
                                    <Grid container  style={{position:'absolute',width:'100%',margin:'auto'}}>
                                        <StartButton data={goldenPathButton}/>
                                    </Grid>
                                </Grid>
                                <Grid className='gift-hall-divider-banner-golden-path' style={{position:'relative',height:'100%'}} container sm={2} xs={2} alignItems={"center"} justify={"center"}>
                                    <Grid container  style={{position:'absolute',width:'100%',margin:'auto'}}>
                                        <img src={CircleOrange} className='gift-hall-divider-banner-score-image' alt=""/>
                                    </Grid>
                                </Grid>
                                <Grid className='gift-hall-divider-banner-regular-path' style={{position:'relative',height:'100%'}}  container sm={4} xs={4} alignItems={"center"} justify={"center"}>
                                    <Grid container style={{position:'absolute',width:'100%',margin:'auto'}}>
                                        <StartButton data={regularPathButton}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {
                                items.map((data,key)=>{
                                    return (
                                        <Grid container onClick={()=>{
                                            if (this.state.data.pointer===key)
                                                this.polygonDetail(data)
                                        }}>
                                            <PolygonHolder data={data} ky={key} originalData={{...this.state.data}}/>
                                        </Grid>
                                        )
                                })
                            }
                        </Grid>
                        {
                            showGoldenPathDialog &&
                            <Grid item alignItems={"center"} justify={"center"} container className='gift-hall-offer'>
                                <GiftHallOffer reward={Rewards_vip} data={shopItem}/>
                            </Grid>
                        }
                        <Grid item style={{
                            borderRadius: '20px 20px 0px 0px',
                            zIndex:'4'
                        }}>
                            <Grid direction='row-reverse' justify={"center"} alignItems={"center"} container className='golden-path-section'>
                                <Grid container alignItems={"center"} justify={"center"} item sm={5} xs={5} style={{position:'relative'
                                }}>
                                    {
                                        showGoldenPathDialog &&
                                        // <p style={{position:'absolute',backgroundColor:'purple',textAlign:'center',
                                        //     transform:'translateY(-200%)'
                                        // }}>
                                        //     {shopItem.fullPrice}
                                        // </p>
                                        <span className='offer-section-single-offer-span-outer' style={{position:'absolute',transform:'translateY(-230%)'}}>
                                                <span className='offer-section-single-offer-span-inner' style={{color:'#ffffff'}}>
                                            تومان{shopItem.fullPrice}
                                                </span>
                                        </span>
                                    }
                                    {
                                        this.state.greenButtonLoader ?(
                                            <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                                  style={{position:'relative'}}
                                            >
                                                <Grid item container justify={"center"} style={{position:'absolute',
                                                }}>
                                                    <PicoLoader/>
                                                </Grid>
                                            </Grid>
                                        ):(
                                            <StartButton clicked={this.handleShowGoldenPathDialog} data={startButton}/>
                                          )
                                    }
                                </Grid>
                                <Grid xs={6} justify={"center"} sm={6} container>
                                    <p>
                                        مسیر طلایی رو فعال کن و جایزه های متنوع و بیشتر بگیر
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    !data &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
    GiftHallDialog:state.GiftHall
})
export default connect(mapStateToProps,{data,giftHallDialog})(GiftHall)